import { Scissors, User } from 'lucide-react'
import type { AccessCode } from '../types'

const WA = (msg: string) =>
  `https://wa.me/33604417682?text=${encodeURIComponent(msg)}`

interface HeaderProps {
  onLogout: () => void
  onOpenCompte: () => void
  salonInfo: AccessCode | null
}

export default function Header({ onLogout: _onLogout, onOpenCompte, salonInfo }: HeaderProps) {
  // Initiales pour l'avatar
  const initiales = salonInfo
    ? `${salonInfo.prenom.charAt(0)}${salonInfo.nom.charAt(0)}`.toUpperCase()
    : null

  return (
    <header className="sticky top-0 z-40" style={{ background: '#1A3C6E', color: 'white' }}>
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between gap-3">

        {/* Logo */}
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex items-center justify-center w-8 h-8 rounded-xl flex-shrink-0"
            style={{ background: 'rgba(255,255,255,0.15)' }}>
            <Scissors className="w-4 h-4 text-white" />
          </div>
          <div className="min-w-0">
            <div className="font-bold text-sm leading-tight truncate">Loris Hug Innovation</div>
            {salonInfo?.salon
              ? <div className="text-xs opacity-70 truncate">💈 {salonInfo.salon}</div>
              : <div className="text-xs opacity-60">Pilotage Salon</div>
            }
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <a
            href={WA('Bonjour Loris, je souhaite en savoir plus sur la version complète de l\'outil Pilotage Salon.')}
            target="_blank" rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-xl font-semibold text-xs transition-all hover:opacity-90"
            style={{ background: 'white', color: '#1A3C6E' }}>
            Version complète →
          </a>

          {/* Bouton Mon compte (avatar) */}
          <button
            onClick={onOpenCompte}
            title="Mon compte"
            className="flex items-center gap-2 px-2.5 py-1.5 rounded-xl text-xs font-medium transition-all hover:opacity-80 group"
            style={{ background: 'rgba(255,255,255,0.12)', color: 'white' }}>
            {/* Avatar */}
            <div className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-blue-900 bg-white group-hover:scale-105 transition-transform">
              {initiales ?? <User size={13} className="text-blue-900" />}
            </div>
            <span className="hidden sm:inline">Mon compte</span>
          </button>
        </div>
      </div>
    </header>
  )
}
